import React from 'react';
import _ from 'lodash';
import { Row, Col } from 'react-bootstrap';
import BannerImageEditor from "src/legacy/components/BannerImageEditor/";
import { ToolBar, ToolBarGroup } from 'src/legacy/components/ToolBar/ToolBar.jsx';
import { ToolBarButtonItem } from 'src/legacy/components/ToolBar/ToolBarButtonItem.jsx';
import DefaultBackground from 'src/legacy/images/collections/DefaultBackground.jpeg';
import { EXPERIENCE_BENTO, EXPERIENCE_CAROUSEL, EXPERIENCE_MASONRY } from 'src/legacy/constants/collectionConstants';
import { localizedStrings } from 'src/localization/index.jsx';
import cx from 'classnames';
import styles from '../../accountManagementView.module.scss';
import Banner from 'src/legacy/components/Banner';
import DealRoomWidgetManager from 'src/services/dealRoom.widget.service';
import { DescriptionEditor } from 'src/pages/dealRoom/components/description';
import userRoleService from 'src/services/userRoles.service';

class DealRoomSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editBanner: false,
      menuState: {
        primaryAction: 'edit'
      }
    }

    this.handleTemplateChange = this.handleTemplateChange.bind(this);
    this.handleEditBannerClicked = this.handleEditBannerClicked.bind(this);
    this.onBackgroundImageChanged = this.onBackgroundImageChanged.bind(this);
    this.handleSharedByClicked = this.handleSharedByClicked.bind(this);

    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedCollectionSettings = this.localizedSettings.account.account_management.tabs.collection_settings;
    this.localizedDefaultExperience = this.localizedCollectionSettings.default_experience;
  }

  handleTemplateChange(value) {
    const settings = this.props.value.dealRoomSettings;
    var request = {
      ...settings,
      description: value
    };

    this.props.onChange(request);
  }

  getBackgroundImage(settings) {
    if (settings.banner && settings.banner.background) {
      var background = settings.banner.background;
      if (typeof background === 'string') {
        return background;
      } else if (background.full) {
        return background.full;
      }
    }

    return DefaultBackground;
  }

  getBackgroundType(banner) {
    if (banner == null) {
      return 'image';
    }

    if (banner.mediaType) {
      return banner.mediaType;
    }

    if (banner.background) {
      return banner.background.type;
    }

    return "image";
  }

  handleEditBannerClicked() {
    this.setState({
      editBanner: true
    })
  }

  onBackgroundImageChanged(data) {
    const settings = this.props.value.dealRoomSettings;
    var request = {
      ...settings,
      banner: {
        ...settings.banner,
        ...data
      }
    };

    this.props.onChange(request);

    this.setState({
      editBanner: false
    });
  }

  handleSharedByClicked() {
    const settings = _.get(this.props,"value.dealRoomSettings");
    const sharedByEnabled = _.get(settings, 'banner.sharedByEnabled', true);
    var request = {
      ...settings,
      banner: {
        ...settings.banner,
        sharedByEnabled: !sharedByEnabled
      }
    };

    this.props.onChange(request);
  }

  render() {
    const settings = _.get(this.props,"value.dealRoomSettings");
    const sharedByEnabled = _.get(settings, 'banner.sharedByEnabled', true);
    const backgroundImage = this.getBackgroundImage(settings);
    const mediaType = this.getBackgroundType(settings.banner);

    return (
      <div className={styles.dealRoomSettings}>
        <div className={styles.wrapper}>
          <Banner value={settings.banner} default={DefaultBackground} />

          <Row className={styles.editor}>
            <Col md={10}>
              <DescriptionEditor
                key={this.props.triggerRerender}
                dealRoom={this.props.value.dealRoomSettings}
                widgetManager={new DealRoomWidgetManager}
                maxHeight={'none'}
                menuState={this.state.menuState}
                onChange={this.handleTemplateChange.bind(this)}
                onMenuChange={(value) => {
                  this.setState({
                    menuState: value
                  })
                }}
              />
            </Col>
            <Col md={5} />
          </Row>
        </div>


        <ToolBar className={styles.toolbar}>
          <ToolBarGroup>
            <ToolBarButtonItem
              className={cx(styles.action)}
              width="auto"
              height="auto"
              disabled={this.props.updating}
              onClick={this.handleEditBannerClicked}>
              <span className="fa fa-file-image" />{this.localizedCollectionSettings.actions.edit_background}
            </ToolBarButtonItem>
            {userRoleService.canShare() &&
              <ToolBarButtonItem
                className={cx(styles.action, styles.sharedBy)}
                width="auto" height="auto"
                onClick={this.handleSharedByClicked}>
                <span className={styles.actionButton}>
                  <span className={cx(!sharedByEnabled ? "fa fa-toggle-off" : "fa fa-toggle-on")}></span>{this.localizedCollectionSettings.actions.show_shared_by}
                </span>
              </ToolBarButtonItem>
            }
          </ToolBarGroup>
        </ToolBar>

        <BannerImageEditor
          entity='collection'
          show={this.state.editBanner}
          onChange={this.onBackgroundImageChanged}
          onCancel={() => {
            this.setState({
              editBanner: false
            });
          }}
          user={this.props.user}
          value={{
            ...settings.banner,
            mediaType: mediaType,
            background: backgroundImage
          }}
          source="Settings"
        />
      </div>
    )
  }
}

export default DealRoomSettings;